module.exports = __webpack_public_path__ + "img/cdc08482cd0516280d683276c485181f.1cbe0847.jpg";